import type {
  MySkillsRequest,
  MySkillStatusResponse,
  SkillMatrixRequest,
  SkillMatrixResponse,
  SkillSignOffCreateRequest,
  SkillSignOffEvaluateRequest,
  SkillSignOffListRequest,
  SkillSignOffMyHistoryRequest,
  SkillSignOffPendingResponse,
  SkillSignOffResponse,
} from 'src/api/ProactApiClient';
import {skillSignOffApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery, voidClientQuery} from '../clientQuery';

export const skillSignOffApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getSkillSignOffInbox: builder.query<
      SkillSignOffPendingResponse[],
      SkillSignOffListRequest
    >({
      queryFn: clientQuery(request => skillSignOffApiClient.getInbox(request)),
      providesTags: ['SkillSignOffs'],
    }),
    getSkillSignOffOversight: builder.query<
      SkillSignOffPendingResponse[],
      SkillSignOffListRequest
    >({
      queryFn: clientQuery(request =>
        skillSignOffApiClient.getOversight(request)
      ),
      providesTags: ['SkillSignOffs'],
    }),
    getSkillSignOff: builder.query<SkillSignOffResponse, number>({
      queryFn: clientQuery(id => skillSignOffApiClient.get(id)),
      providesTags: ['SkillSignOffs'],
    }),
    createSkillSignOff: builder.mutation<
      SkillSignOffResponse,
      SkillSignOffCreateRequest
    >({
      queryFn: clientQuery(request => skillSignOffApiClient.create(request)),
      invalidatesTags: ['SkillSignOffs'],
    }),
    evaluateSkillSignOff: builder.mutation<
      SkillSignOffResponse,
      SkillSignOffEvaluateRequest
    >({
      queryFn: clientQuery(request => skillSignOffApiClient.evaluate(request)),
      invalidatesTags: ['SkillSignOffs'],
    }),
    cancelSkillSignOff: builder.mutation<void, number>({
      queryFn: voidClientQuery(id => skillSignOffApiClient.cancel(id)),
      invalidatesTags: ['SkillSignOffs'],
    }),
    getSkillMatrix: builder.query<SkillMatrixResponse, SkillMatrixRequest>({
      queryFn: clientQuery(request => skillSignOffApiClient.getMatrix(request)),
      providesTags: ['SkillSignOffs'],
    }),
    getMySkills: builder.query<MySkillStatusResponse[], MySkillsRequest>({
      queryFn: clientQuery(request => skillSignOffApiClient.getMySkills(request)),
      providesTags: ['SkillSignOffs'],
    }),
    getMySkillSignOffHistory: builder.query<
      SkillSignOffResponse[],
      SkillSignOffMyHistoryRequest
    >({
      queryFn: clientQuery(request => skillSignOffApiClient.getMyHistory(request)),
      providesTags: ['SkillSignOffs'],
    }),
    getSkillSignOffRecords: builder.query<
      SkillSignOffResponse[],
      SkillSignOffListRequest
    >({
      queryFn: clientQuery(request => skillSignOffApiClient.getRecords(request)),
      providesTags: ['SkillSignOffs'],
    }),
  }),
});

export const {
  useGetSkillSignOffInboxQuery,
  useGetSkillSignOffOversightQuery,
  useGetSkillSignOffQuery,
  useCreateSkillSignOffMutation,
  useEvaluateSkillSignOffMutation,
  useCancelSkillSignOffMutation,
  useGetSkillMatrixQuery,
  useLazyGetSkillMatrixQuery,
  useGetMySkillsQuery,
  useGetMySkillSignOffHistoryQuery,
  useGetSkillSignOffRecordsQuery,
} = skillSignOffApi;
